/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const widget_android_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M2 3.62c0-.565.457-1.022 1.021-1.022h6.127a1.02 1.02 0 0 1 1.021 1.021v6.127a1.02 1.02 0 0 1-1.021 1.021H3.021A1.021 1.021 0 0 1 2 9.747V3.618Zm10.934 3.785a1.021 1.021 0 0 1 0-1.444l3.661-3.662a1.021 1.021 0 0 1 1.444 0l3.662 3.662a1.021 1.021 0 0 1 0 1.444l-3.662 3.661a1.021 1.021 0 0 1-1.444 0l-3.661-3.661ZM2 14.852a1.02 1.02 0 0 1 1.021-1.021h6.127a1.02 1.02 0 0 1 1.021 1.021v6.127A1.02 1.02 0 0 1 9.148 22H3.021A1.021 1.021 0 0 1 2 20.979v-6.127Zm11.233 0a1.02 1.02 0 0 1 1.02-1.021h6.128c.564 0 1.02.457 1.02 1.021v6.127A1.02 1.02 0 0 1 20.381 22h-6.127a1.021 1.021 0 0 1-1.021-1.021v-6.127Z"
    />
  </svg>
)
export default widget_android_medium
